<template>
  <PageHeader title="Knowledge Base" subtitle="Manage documents for the AI chatbot knowledge base" />

  <TableLayout>
    <DocumentUpload @select="handleUpload" />

    <EmptyState
      v-if="documents.length === 0"
      title="No documents uploaded yet"
      description="Upload PDF, Word, or Excel files to build the AI chatbot's knowledge base."
    />

    <DocumentsTable v-else :documents="documents" @delete="handleDelete" />
  </TableLayout>
</template>

<script setup>
import { onMounted } from "vue";
import PageHeader from "@/components/PageHeader.vue";
import TableLayout from "@/layouts/TableLayout.vue";
import EmptyState from "@/components/EmptyState.vue";
import DocumentUpload from "@/views/DocumentsView/components/DocumentUpload.vue";
import DocumentsTable from "@/views/DocumentsView/components/DocumentsTable.vue";
import { useDocuments } from "@/composables/useDocuments";

const { documents, fetchDocuments, selectFile, uploadDocument, deleteDocument } = useDocuments();

const handleUpload = async (file) => {
  const valid = selectFile(file);
  if (!valid) return;
  await uploadDocument();
};

const handleDelete = async (doc) => {
  if (!confirm(`Are you sure you want to delete "${doc.title}"? This will also remove all associated chunks from the knowledge base.`)) return;
  await deleteDocument(doc);
};

onMounted(fetchDocuments);
</script>
